import { type PopoverProps, Popover as _Popover } from './popover';
import { PopoverDialog, type PopoverDialogProps } from './popover.dialog';
import { PopoverTrigger, type PopoverTriggerProps } from './popover.trigger';

const Popover = Object.assign(_Popover, {
  Dialog: PopoverDialog,
  Trigger: PopoverTrigger,
});

export type { PopoverDialogProps, PopoverProps, PopoverTriggerProps };
export { Popover };
